export default __webpack_public_path__ + "static/media/sn-syotoku.f24d1940.jpg";